import mock from "../mock"

export const searchResult = [
  {
    groupTitle: "Pages",
    searchLimit: 4,
    data: [
      {
        id: 1,
        target: "home",
        title: "Home",
        link: "/",
        icon: "Home"
      },
      {
        id: 2,
        target: "page",
        title: "Novo Numero",
        link: "/vincule-number",
        icon: "File"
      },
      {
        id: 4,
        target: "Chat",
        title: "Chat",
        link: "/chat",
        icon: "MessageSquare"
      },
      {
        id: 4,
        target: "Ajuda",
        title: "Ajuda",
        link: "/faq",
        icon: "HelpCircle"
      }
    ]
  }
]

mock.onGet("/api/main-search/data").reply(200, {
  searchResult
})
